import { Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../services/lang/lang';
import SingleNote from './SingleNote';
import { RenderIf } from '../RenderIf/RenderIf';
import { useTokens } from '../../../context/TokenProvider';
const NotesList = ({ notes, onNotesMutated, canEdit }) => {
    const tokens = useTokens();
    return (React.createElement(VStack, { "data-testid": "notes_list", maxHeight: 400, overflowY: "auto", spacing: tokens.Spacing05, py: tokens.Spacing05, align: "start" },
        React.createElement(RenderIf, { condition: !notes.length },
            React.createElement(Text, { "data-testid": "notes_list__none_added" }, localise('NONE_ADDED'))),
        notes.map((note) => (React.createElement(SingleNote, { key: note.id, canDelete: canEdit, onNotesMutated: onNotesMutated, note: note })))));
};
export default NotesList;
